import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Bell, Search, ChevronDown, Menu, Sun, MoonStar } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { ROUTE_META } from '../../Models/navigationData'
import { fetchProfile } from '../../Components/pages/AdminProfile/services/profileSlice'

export default function Header({ onMenuOpen, theme, onThemeToggle }) {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { title, parent } = ROUTE_META[pathname] || { title: 'Panel', parent: 'Admin' }

  const { profile } = useSelector((state) => state.profile)

  // sessionStorage ma data nathi hoy (ke refresh pachi) to API thi lavo
  useEffect(() => {
    if (!profile?.name) dispatch(fetchProfile())
  }, [dispatch, profile?.name])

  const name = profile?.name || 'Admin'
  const role = profile?.login_type || 'Admin'
  const initials =
    name.trim().split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase() || 'AD'

  return (
    <>
      <header className="app-header">
        <button className="btn btn-ghost btn-icon hdr-menu" onClick={onMenuOpen} aria-label="Open menu">
          <Menu size={17} />
        </button>

        <div className="hdr-breadcrumb">
          <span className="hdr-parent">{parent}</span>
          <span className="hdr-sep">/</span>
          <span className="hdr-page">{title}</span>
        </div>

        <div className="hdr-right">
          {/* <div className="hdr-search">
            <Search size={13} className="hdr-search-ic" />
            <input className="hdr-search-input" placeholder="Search…" aria-label="Global search" />
            <span className="hdr-kbd">⌘K</span>
          </div>

          <button className="btn btn-ghost btn-icon hdr-notif" aria-label="Notifications">
            <Bell size={16} />
            <span className="hdr-badge">4</span>
          </button> */}
          <button
            className="btn btn-ghost btn-icon"
            aria-label="Toggle color theme"
            onClick={onThemeToggle}
          >
            {theme === 'dark' ? <Sun size={16} /> : <MoonStar size={16} />}
          </button>

          <span className="hdr-divider" />

          <div className="hdr-admin">
            <div className="hdr-avatar">
              {profile?.profile_image
                ? <img src={profile.profile_image} alt={name} />
                : initials}
            </div>
            <div className="hdr-info">
              <span className="hdr-name">{name}</span>
              <span className="hdr-role">{role}</span>
            </div>
            <ChevronDown size={13} className="hdr-chevron" />
          </div>
        </div>
      </header>

      <style>{`
        .app-header {
          height: var(--header-height);
          background: var(--bg-surface); border-bottom: 1px solid var(--border);
          display: flex; align-items: center; padding: 0 var(--space-lg);
          gap: var(--space-sm); position: sticky; top: 0; z-index: 50; flex-shrink: 0;
        }
        .hdr-menu { display: none; flex-shrink: 0; color: var(--text2); }
        .hdr-breadcrumb {
          display: flex; align-items: center; gap: 6px; flex: 1; min-width: 0; overflow: hidden;
        }
        .hdr-parent { font-size: var(--fs-sm); font-weight: 500; color: var(--text3); white-space: nowrap; }
        .hdr-sep    { color: var(--text4); font-size: var(--fs-sm); flex-shrink: 0; }
        .hdr-page   { font-size: var(--fs-md); font-weight: 600; color: var(--text1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .hdr-right  { display: flex; align-items: center; gap: var(--space-sm); flex-shrink: 0; }
        .hdr-search {
          display: flex; align-items: center; gap: var(--space-xs);
          background: var(--bg-raised); border: 1px solid var(--border);
          border-radius: var(--radius-sm); padding: 0 0.6rem; height: 34px;
          width: clamp(120px, 14vw, 200px); flex-shrink: 0;
          transition: border-color var(--ease-base), box-shadow var(--ease-base);
        }
        .hdr-search:focus-within { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-glow-sm); }
        .hdr-search-ic { color: var(--text3); flex-shrink: 0; }
        .hdr-search-input {
          background: none; border: none; outline: none; color: var(--text1);
          font-family: var(--font-body); font-size: var(--fs-sm); width: 100%; min-width: 0;
        }
        .hdr-search-input::placeholder { color: var(--text3); }
        .hdr-kbd {
          font-family: var(--font-mono); font-size: 10px; color: var(--text4);
          background: var(--bg-base); border: 1px solid var(--border-subtle);
          border-radius: 4px; padding: 1px 5px; white-space: nowrap; flex-shrink: 0;
        }
        .hdr-notif { position: relative; color: var(--text2); }
        .hdr-badge {
          position: absolute; top: 4px; right: 4px; width: 14px; height: 14px;
          background: var(--accent); border-radius: var(--radius-full);
          font-size: 9px; font-weight: 700; color: #fff;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 0 8px var(--accent-glow);
        }
        .hdr-divider { width: 1px; height: 22px; background: var(--border-subtle); flex-shrink: 0; }
        .hdr-admin {
          display: flex; align-items: center; gap: 0.5rem; cursor: pointer; flex-shrink: 0;
          padding: 4px 8px; border-radius: var(--radius-sm); transition: background var(--ease-fast);
        }
        .hdr-admin:hover { background: var(--bg-hover); }
        .hdr-avatar {
          width: 32px; height: 32px; border-radius: var(--radius-full);
          background: linear-gradient(135deg, var(--accent), var(--accent-hover));
          display: flex; align-items: center; justify-content: center;
          font-size: var(--fs-xs); font-weight: 700; color: #fff; flex-shrink: 0;
          box-shadow: 0 0 10px var(--accent-glow); overflow: hidden;
        }
        .hdr-avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .hdr-info  { display: flex; flex-direction: column; line-height: 1.2; }
        .hdr-name  { font-size: var(--fs-sm); font-weight: 600; color: var(--text1); white-space: nowrap; max-width: 140px; overflow: hidden; text-overflow: ellipsis; }
        .hdr-role  { font-size: 10px; font-weight: 500; color: var(--accent-hover); white-space: nowrap; text-transform: capitalize; }
        .hdr-chevron { color: var(--text3); flex-shrink: 0; }
        @media (max-width: 768px) {
          .app-header { padding: 0 var(--space-md); gap: var(--space-xs); }
          .hdr-menu { display: flex !important; }
          .hdr-search { display: none !important; }
          .hdr-info { display: none; }
          .hdr-parent, .hdr-sep { display: none; }
        }
      `}</style>
    </>
  )
}